import React from 'react';
import {connect} from 'react-redux';
import ButtonBar from "../../qwc2/components/widgets/ButtonBar";
import PropTypes from "prop-types";
import FeatureDetailsTab from "./FeatureDetailsTab";
import FeatureBreadcrumb from "./FeatureBreadcrumb";
import RoleUtils from "../utils/RoleUtils";
import LocaleUtils from "../../qwc2/utils/LocaleUtils";
import {setDetailWindowTab} from "../actions/details";

class FeatureDetailsView extends React.Component {
    static propTypes = {
        breadcrumbUrl: PropTypes.string,
        feature: PropTypes.object,
        initialTab: PropTypes.string,
        isDirty: PropTypes.bool,
        setDetailWindowTab: PropTypes.func,
        tabs: PropTypes.array,
        type: PropTypes.string,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }
    static defaultProps = {
        feature: {},
        tabs: [],
        type: '',
        windowId: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            // Restored from the window history, falls back to the first tab if it does not exist anymore
            currentTab: props.initialTab || '',
            labels: {},
            additionalTabs: {}
        };
    }

    componentDidUpdate() {
    }

    setTab = (tabkey) => {
        if (this.props.isDirty && !window.confirm(LocaleUtils.tr("featuredetails.unsavedchanges"))) {
            return;
        }
        this.setState({currentTab: tabkey});
        this.props.setDetailWindowTab(this.props.windowId, tabkey);
    }

    getCurrentTab() {
        const tabs = this.getTabs();
        if (this.state.currentTab === '' || !tabs.some(tab => this.getTabKey(tab) === this.state.currentTab)) {
            if (tabs[0]) {
                return this.getTabKey(tabs[0]);
            }
        }
        return this.state.currentTab;
    }

    getTabKey(tab) {
        return tab.view + "|" + tab.url + "|" + tab.label + "|" + this.props.feature.properties.id;
    }

    getTabs() {
        const tabs = [...this.props.tabs];
        Object.keys(this.state.additionalTabs).forEach(k => {
            tabs.push(this.state.additionalTabs[k]);
        });
        return tabs.filter(tab => RoleUtils.hasAnyRole(tab.roles));
    }

    render() {
        let tabs = "";
        const self = this;
        if (this.getTabs() !== null) {
            const buttons = [];
            this.getTabs().forEach(t => {
                const tabKey = self.getTabKey(t);
                t.id = tabKey;
                buttons.push({
                    key: tabKey,
                    // labels may be message ids (e.g. components.edit), the button bar does not translate them
                    label: LocaleUtils.tr(this.state.labels[tabKey] || t.label)
                });
            });
            tabs = (
                <div className="feature-details-tabs">
                    <ButtonBar active={this.getCurrentTab()} buttons={buttons} onClick={this.setTab}/>
                    {this.getTabs().map(tab => {
                        return this.renderTab(tab);
                    })}
                </div>
            );
        }

        let breadcrumb = '';
        if (this.props.type) {
            breadcrumb = (
                <FeatureBreadcrumb feature={this.props.feature} type={this.props.type} url={this.props.breadcrumbUrl}
                    windowId={this.props.windowId} windowType={this.props.windowType}/>
            );
        }

        return (
            <div className="feature-details">
                {breadcrumb}
                {tabs}
            </div>
        );
    }

    labelUpdate(tab, newLabel) {
        const tabKey = this.getTabKey(tab);
        const labels = this.state.labels;
        labels[tabKey] = newLabel;
        this.setState({labels: labels});
    }

    addTab(index, newTab) {
        const additionalTabs = this.state.additionalTabs;
        additionalTabs[index] = newTab;
        this.setState({
            currentTab: this.getTabKey(newTab),
            additionalTabs: additionalTabs
        });
        this.props.setDetailWindowTab(this.props.windowId, this.getTabKey(newTab));
    }

    renderTab(tab) {
        return (
            <FeatureDetailsTab addTab={(i, t) => this.addTab(i, t)} feature={this.props.feature}
                               key={this.getTabKey(tab)}
                               labelUpdate={(newLabel) => this.labelUpdate(tab, newLabel)}
                               tab={tab} visible={this.getTabKey(tab) === this.getCurrentTab()}
                               windowId={this.props.windowId} windowType={this.props.windowType}/>
        );
    }
}

const selector = (state, ownProps) => ({
    isDirty: !!state.dirty[ownProps.windowId]
});

export default connect(selector, {
    setDetailWindowTab: setDetailWindowTab
})(FeatureDetailsView);
